import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './ErrorSlot.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var BaseErrorSlot = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inputName = _ref.inputName,
      errorText = _ref.errorText,
      helperLink = _ref.helperLink,
      helperText = _ref.helperText,
      fullErrorMessageGap = _ref.fullErrorMessageGap,
      tokens = _ref.tokens;
  return _jsx(views.ErrorWrapper, {
    ref: ref,
    title: errorText,
    initial: "initial",
    variants: {
      initial: {
        opacity: 0,
        y: 5
      },
      animate: {
        opacity: 1,
        y: 0
      }
    },
    animate: errorText ? "animate" : "initial",
    transition: {
      duration: 0.2
    },
    fullErrorMessageGap: fullErrorMessageGap,
    children: errorText && _jsx(_Fragment, {
      children: _jsxs(views.LabelWrapper, _objectSpread(_objectSpread({
        showFullMessage: Boolean(fullErrorMessageGap)
      }, tokens), {}, {
        children: [_jsx(views.ErrorLabel, _objectSpread(_objectSpread({
          variant: "textRegularSmall",
          id: "".concat(inputName, "-message"),
          role: "alert"
        }, tokens), {}, {
          children: errorText
        })), helperLink ? _jsx(views.HelperLink, {
          variant: "textRegularSmall",
          children: _jsx("a", {
            href: helperLink,
            children: helperText
          })
        }) : null]
      }))
    })
  });
});
var ErrorSlot = withDesignTokens(BaseErrorSlot, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.status.error[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.status.error[100]
    };
  }
});
export default ErrorSlot;